import React from 'react';
import { ListBase, Create, Edit, SimpleForm, TextField, ReferenceField, 
  EditButton, TextInput, BooleanInput, ReferenceInput, AutocompleteInput, Filter,
  Pagination, CreateButton } from 'react-admin';
import DatagridConfigurable from '../../lib/DatagridConfigurable.tsx';
import { SelectColumnsButton } from '../../lib/SelectColumnsButton.tsx';
import Stack from '@mui/material/Stack';
import CloseToolbar from '../../lib/CloseToolbar';
import NoPagination from '../../lib/NoPagination';


const ListToolbar = () => {
  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <ListFilter />
        <Stack alignItems="flex-start">
          <SelectColumnsButton />
        </Stack>
        <Stack alignItems="flex-start">
          <CreateButton />
        </Stack>
      </Stack>
    </>
  )
}

const ListFilter = ({ ...props }) => {
  return (
    <Filter {...props}>
      <ReferenceInput source="id_agent" reference="globPortalinfo/agents" alwaysOn perPage={1000} sort={{id: 'DESC'}}>
        <AutocompleteInput optionText="firma" label="Agent" sx={{width: '22em'}} />
      </ReferenceInput>
      <TextInput source="schluessel" resettable alwaysOn inputProps={{ 'data-lpignore': 'true', autoComplete: 'off' }}/>
      <BooleanInput source="all_hostel" label="All Hostels" alwaysOn/>
    </Filter>
  )
};

const ListForm = (props) => {
  return (
    <ListBase {...props} filter={{global: true}} filters={<ListFilter />} title="bw.set.prefcountry.title" sort={{ field: 'id_agent', order: 'ASC' }} pagination={<NoPagination />} perPage={1000} >
      <ListToolbar />
      <DatagridConfigurable style={{ width: 'auto' }} bulkActionButtons={false} omit={['id_hostel']} >
        <ReferenceField source="id_agent" reference="globPortalinfo/agents" label="Agent" >
          <TextField source="firma"/>
        </ReferenceField>
        <TextField source="id_hostel" label="hid" />
        <TextField source="schluessel" />
        <TextField source="wert" sx={{whiteSpace: 'normal', wordBreak: 'break-all'}} />
        <EditButton label="" noSelect={true} />
      </DatagridConfigurable>
      <Pagination />
    </ListBase>
  )
}

const CEForm = ({classes, hasList, hasEdit, hasCreate, hasShow, ...props}) => {
  return (
    <SimpleForm toolbar={<CloseToolbar />} {...props}> 
      <TextInput source="id_agent" />
      <ReferenceInput source="id_agent"  reference="globPortalinfo/agents" perPage={1000} sort={{ field: 'id', order: 'ASC' }} >
        <AutocompleteInput optionText="firma" label="Agent"/>
      </ReferenceInput>
      <TextInput source="schluessel" />
      <TextInput source="wert" fullWidth multiline />
      <TextInput source="global" defaultValue={true} type="hidden" label="" sx={{width: 0}} />
    </SimpleForm>
  )
};

const Portalinfo = {
  list: ({ classes, ...props }) => (
    <ListForm {...props} classes={classes} />
  ),
  
  create: ({classes, ...props }) => (
    <Create {...props} title="bw.set.prefcountry.titleCreate" redirect="list">
      <CEForm {...props} classes={classes} />
    </Create>
  ),
  
  edit: ({ classes, ...props }) => (
    <Edit title="bw.set.prefcountry.titleEdit" mutationMode="pessimistic" {...props}>
      <CEForm {...props} classes={classes} />
    </Edit>
  )
}   
export default Portalinfo